import React from 'react';
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import PDAHeader from "src/components/common/Header";
import usePDA1090_R01Store from "./usePDA1090_R01Store";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import PDA1090_R01Form from "./PDA1090_R01Info";
import PDA1090_R01Table from "./PDA1090_R01Table";

/**
 * PDA1090_R01 재고실사 등록 메인 컨테이너
 * 
 * 기능:
 * - LOT 스캔으로 품목/재고 정보 조회
 * - 창고별 재고 현황 표시
 * - 실재고 입력 후 재고 조정
 * - 수불 이력 자동 생성
 * 
 * 화면 구성:
 * - 상단(2/3): LOT 스캔 + 품목 정보 + 실재고 입력
 * - 하단(1/3): 창고별 재고 현황 그리드
 */
interface PDA1090_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1090_R01Container = ({ 
  menuNm, 
  menuCd, 
  onBack 
}: PDA1090_R01ContainerProps) => {
  const { loading, reset } = usePDA1090_R01Store();

  const { handleMenuClick } = usePDAContainer(reset);

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      {/* 헤더 */}
      <PDAHeader 
        menuNm={menuNm} 
        menuCd={menuCd} 
        onBack={onBack} 
        onMenuClick={handleMenuClick} 
      />

      {/* 메인 콘텐츠 */}
      <div className="flex-1 overflow-hidden flex flex-col">
        {/* 상단: 재고실사 입력 폼 (2/3) */}
        <div className="h-3/5 overflow-y-auto">
          <PDA1090_R01Form />
        </div>

        {/* 하단: 창고별 재고 현황 테이블 (2/5) */}
        <div className="h-3/5 overflow-hidden">
          <PDA1090_R01Table />
        </div>
      </div>

      {/* 로딩 스피너 */}
      {loading && <SpinnerOverlay text="처리 중..." />}
    </div>
  );
};

export default PDA1090_R01Container;
